<section class="video-section">
  <app-page-header
    searchPlaceholder="Search by title..."
    [pageTitle]="'Videos'"
    [numberOfItem]="videosCount"
    (searchEvent)="handleSearch($event)"
    [loading]="
      videoListLoading &&
      (videoFilter | async)?.pageNumber === 1 &&
      !videosCount
    "
  >
    <button
      class="button"
      addButton
      [routerLink]="'/add-video'"
      *ngIf="isAdmin"
    >
      <img src="assets/images/add.svg" alt="+" />
      Add <span> Video</span>
    </button>
  </app-page-header>

  <div class="video-section__list flex-wrap">
    <ng-container
      *ngIf="
        videoListLoading && (videoFilter | async)?.pageNumber === 1;
        else videoList
      "
    >
      <div class="video-section__item" *ngFor="let i of [].constructor(3)">
        <div class="video-section__card">
          <app-skeleton [ratio]="1 / 1" margin="0 0 10px"></app-skeleton>
          <app-skeleton
            height="15px"
            width="80%"
            margin="0 0 3px"
          ></app-skeleton>
          <app-skeleton height="10px" width="90%"></app-skeleton>
          <app-skeleton
            height="10px"
            width="70%"
            margin="0 0 8px"
          ></app-skeleton>
          <div>
            <app-skeleton height="10px" width="100px"></app-skeleton>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>

<ng-container *ngIf="deleteVideoId">
  <app-confirmation-modal
    primaryButtonText="Cancel"
    secondaryButtonText="Yes"
    message="Are you sure you want to delete this video ?"
    caption="Delete Confirmation"
    (onPrimaryButtonClick)="cancelDelete()"
    (onSecondaryButtonClick)="deleteVideo()"
    [secondaryButtonLoading]="deleteLoading"
  ></app-confirmation-modal>
</ng-container>

<ng-template #videoList>
  <ng-container *ngIf="videos.length > 0; else noDataFound">
    <ng-container *ngFor="let video of videos; let i = index">
      <div class="video-section__item">
        <app-video-card
          (videoPlay)="selectVideo(video)"
          [videoData]="video"
          [isMenuOpen]="menuOpenIndex === i"
          (closeMenuEmitter)="closeAllMenu(i)"
          (openMenuEmitter)="openMenu(i)"
          [lastElement]="videos.length === i + 1"
          (loadMoreIfLastIndexEmitter)="loadMoreIfLastIndex()"
          (onDeleteVideoEmitter)="onDeleteVideo($event)"
        ></app-video-card>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #noDataFound>
  <div class="video-section__nodata">
    <p>No data found</p>
  </div>
</ng-template>

<app-video-modal
  [video]="selectedVideo"
  (close)="handleVideoClose()"
></app-video-modal>
